// import { noTokenAjax } from 'grt-tool-lib-front';
import { useEffect } from 'react';
import withRouter from '@/components/withRouter';
import { isMobile } from 'react-device-detect';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
import { mobileURL, passPortURL } from '@/httpService/API';
import { inject, observer } from 'mobx-react';
import shareLinkJson from './shareLink.json';
const ShareLink = (props) => {
    let login = props.store.login,
        search = window.location.search,
        type = props.params.type;
    //判断pc还是移动端，跳转到对应页面
    const handleHref = async (obj) => {
            let tentantInfo = await login.getCurTenantInfo(),
                TENANT_KEY = tentantInfo?.data?.id,
                { protocol, host } = window.location,
                href = null,
                path = `${protocol}//${host}`;

            if (isMobile) {
                href = `${path}/mobile${obj['mobile']}${search}`;

                if (obj['wxShare']) {
                    href = `${passPortURL}/wx-share?url=${encodeURIComponent(href)}`;
                }
                if (obj['mobileUrl']) {
                    href = `${mobileURL}/mobile/${TENANT_KEY}${obj['mobile']}${search}&TENANT_KEY=${TENANT_KEY}`;
                }
            } else {
                href = `${path}/web${obj['pc']}${search}`;
            }
            window.location.replace(href);
        },
        //获取链接的配置项
        getConfig = async () => {
            // let res = await noTokenAjax.get('https://function-attachment-upload.obs.cn-north-4.myhuaweicloud.com/shareLink.json');
            if (shareLinkJson[type]) {
                let obj = shareLinkJson[type];
                handleHref(obj);
            }
        };
    useEffect(() => {
        if (type) {
            getConfig();
        }
    }, [type]);
    useEffect(() => {
        console.log(login.tenantInfo, 'props');
    }, [login.tenantInfo]);
    return (
        <div>
            <GrtLoading></GrtLoading>
        </div>
    );
};
export default withRouter(inject('store')(observer(ShareLink)));
